// extracted by mini-css-extract-plugin
module.exports = {"item":"_2F16Y","icon_wrapper":"_3-dOu","icon":"C0JtF","name":"_3g_rO","text":"_1BLJH"};